const y = "styles-module__typography___HafR4", _ = "styles-module__H1___edZqH", r = "styles-module__H2___vEpt0", p = "styles-module__paragraph___zTqfP", t = {
  typography: y,
  "typography--lowercase": "styles-module__typography--lowercase___fJAIR",
  "typography--uppercase": "styles-module__typography--uppercase___9yDc1",
  "typography--capitalize": "styles-module__typography--capitalize___2doq7",
  "typography--text-align-left": "styles-module__typography--text-align-left___MKMb2",
  "typography--text-align-right": "styles-module__typography--text-align-right___7q1go",
  "typography--text-align-center": "styles-module__typography--text-align-center___XBUFL",
  "typography--text-align-justify": "styles-module__typography--text-align-justify___tnXHP",
  "typography--size-n3": "styles-module__typography--size-n3___dxFwi",
  "typography--size-n2": "styles-module__typography--size-n2___hVzre",
  "typography--size-n1": "styles-module__typography--size-n1___VYaH6",
  "typography--size-0": "styles-module__typography--size-0___sC2VQ",
  "typography--size-1": "styles-module__typography--size-1___qPnRL",
  "typography--size-2": "styles-module__typography--size-2___CuQV-",
  "typography--size-3": "styles-module__typography--size-3___J4NGh",
  "typography--size-4": "styles-module__typography--size-4___n-FLM",
  "typography--size-5": "styles-module__typography--size-5___tRB8n",
  "typography--bold": "styles-module__typography--bold___12gsd",
  "typography--semibold": "styles-module__typography--semibold___r-3IS",
  "typography--regular": "styles-module__typography--regular___p-qhl",
  "typography--primary": "styles-module__typography--primary___zZy35",
  "typography--primary-blue": "styles-module__typography--primary-blue___jM4V9",
  "typography--primary-dark": "styles-module__typography--primary-dark___qzhpQ",
  "typography--primary-light": "styles-module__typography--primary-light___Ry22T",
  "typography--primary-brand": "styles-module__typography--primary-brand___XcdWt",
  "typography--secondary": "styles-module__typography--secondary___SjkQ8",
  "typography--secondary-50": "styles-module__typography--secondary-50___VWQ03",
  "typography--secondary-100": "styles-module__typography--secondary-100___Gr-IY",
  "typography--secondary-200": "styles-module__typography--secondary-200___1Cos9",
  "typography--secondary-300": "styles-module__typography--secondary-300___CBpYw",
  "typography--secondary-400": "styles-module__typography--secondary-400___CbU4Y",
  "typography--secondary-500": "styles-module__typography--secondary-500___FzzEH",
  "typography--secondary-600": "styles-module__typography--secondary-600___2OrtT",
  "typography--secondary-700": "styles-module__typography--secondary-700___Q2GRw",
  "typography--secondary-800": "styles-module__typography--secondary-800___rYWW5",
  "typography--secondary-900": "styles-module__typography--secondary-900___xgJVI",
  "typography--tertiary": "styles-module__typography--tertiary___tgWLZ",
  "typography--tertiary-50": "styles-module__typography--tertiary-50___XHmRF",
  "typography--tertiary-100": "styles-module__typography--tertiary-100___iTyZQ",
  "typography--tertiary-200": "styles-module__typography--tertiary-200___6C2Pj",
  "typography--tertiary-300": "styles-module__typography--tertiary-300___A63jc",
  "typography--tertiary-400": "styles-module__typography--tertiary-400___sLgeE",
  "typography--tertiary-450": "styles-module__typography--tertiary-450___5QXyv",
  "typography--tertiary-500": "styles-module__typography--tertiary-500___NedyD",
  "typography--tertiary-600": "styles-module__typography--tertiary-600___TPG8f",
  "typography--tertiary-700": "styles-module__typography--tertiary-700___hw4VH",
  "typography--tertiary-800": "styles-module__typography--tertiary-800___5zt8j",
  "typography--tertiary-900": "styles-module__typography--tertiary-900___l-WgV",
  "typography--quaternary": "styles-module__typography--quaternary___-FNF6",
  "typography--quaternary-50": "styles-module__typography--quaternary-50___CfnuA",
  "typography--quaternary-100": "styles-module__typography--quaternary-100___teBo-",
  "typography--quaternary-200": "styles-module__typography--quaternary-200___yj7N-",
  "typography--quaternary-300": "styles-module__typography--quaternary-300___YgE5C",
  "typography--quaternary-400": "styles-module__typography--quaternary-400___5Y3-3",
  "typography--quaternary-500": "styles-module__typography--quaternary-500___Yl7s-",
  "typography--quaternary-600": "styles-module__typography--quaternary-600___tor5e",
  "typography--quaternary-700": "styles-module__typography--quaternary-700___QXqLw",
  "typography--quaternary-800": "styles-module__typography--quaternary-800___YsCqD",
  "typography--quaternary-900": "styles-module__typography--quaternary-900___kywv9",
  "typography--info": "styles-module__typography--info___qhGiy",
  "typography--info-50": "styles-module__typography--info-50___QMv2C",
  "typography--info-100": "styles-module__typography--info-100___E36AU",
  "typography--info-200": "styles-module__typography--info-200___v-cp7",
  "typography--info-300": "styles-module__typography--info-300___0IBFM",
  "typography--info-400": "styles-module__typography--info-400___cVAeP",
  "typography--info-500": "styles-module__typography--info-500___SYf66",
  "typography--info-600": "styles-module__typography--info-600___owleV",
  "typography--info-700": "styles-module__typography--info-700___Www58",
  "typography--info-800": "styles-module__typography--info-800___-ovSe",
  "typography--info-900": "styles-module__typography--info-900___dKoB-",
  "typography--success": "styles-module__typography--success___tV-uM",
  "typography--success-50": "styles-module__typography--success-50___hUTnp",
  "typography--success-100": "styles-module__typography--success-100___uOHFs",
  "typography--success-200": "styles-module__typography--success-200___9MoIA",
  "typography--success-300": "styles-module__typography--success-300___21c73",
  "typography--success-400": "styles-module__typography--success-400___LAl20",
  "typography--success-500": "styles-module__typography--success-500___agNzA",
  "typography--success-600": "styles-module__typography--success-600___3jpOL",
  "typography--success-700": "styles-module__typography--success-700___7OHr6",
  "typography--success-800": "styles-module__typography--success-800___-PznX",
  "typography--success-900": "styles-module__typography--success-900___A4slG",
  "typography--alert": "styles-module__typography--alert___xyViA",
  "typography--alert-50": "styles-module__typography--alert-50___g3tUs",
  "typography--alert-100": "styles-module__typography--alert-100___ebD6j",
  "typography--alert-200": "styles-module__typography--alert-200___9q1Ar",
  "typography--alert-300": "styles-module__typography--alert-300___23ToI",
  "typography--alert-400": "styles-module__typography--alert-400___-UQXh",
  "typography--alert-500": "styles-module__typography--alert-500___4HeMb",
  "typography--alert-600": "styles-module__typography--alert-600___C-qAj",
  "typography--alert-700": "styles-module__typography--alert-700___HrENj",
  "typography--alert-800": "styles-module__typography--alert-800___ZGsk2",
  "typography--alert-900": "styles-module__typography--alert-900___nalx5",
  "typography--error": "styles-module__typography--error___hCCAp",
  "typography--error-50": "styles-module__typography--error-50___8Hg1O",
  "typography--error-100": "styles-module__typography--error-100___lnb9C",
  "typography--error-200": "styles-module__typography--error-200___-GE-w",
  "typography--error-300": "styles-module__typography--error-300___xytqC",
  "typography--error-400": "styles-module__typography--error-400___sbBwY",
  "typography--error-500": "styles-module__typography--error-500___4K-sf",
  "typography--error-600": "styles-module__typography--error-600___8tuhD",
  "typography--error-700": "styles-module__typography--error-700___0w8Ni",
  "typography--error-800": "styles-module__typography--error-800___mSFbG",
  "typography--error-900": "styles-module__typography--error-900___-hPZV",
  "typography--neutral": "styles-module__typography--neutral___2yUv8",
  "typography--neutral-50": "styles-module__typography--neutral-50___zMnlu",
  "typography--neutral-100": "styles-module__typography--neutral-100___MePXr",
  "typography--neutral-150": "styles-module__typography--neutral-150___7fwsL",
  "typography--neutral-200": "styles-module__typography--neutral-200___-A-qd",
  "typography--neutral-300": "styles-module__typography--neutral-300___lhcDX",
  "typography--neutral-400": "styles-module__typography--neutral-400___Gh4yP",
  "typography--neutral-500": "styles-module__typography--neutral-500___WPPiV",
  "typography--neutral-600": "styles-module__typography--neutral-600___FkQbj",
  "typography--neutral-700": "styles-module__typography--neutral-700___gZ01q",
  "typography--neutral-800": "styles-module__typography--neutral-800___B1lBo",
  "typography--neutral-900": "styles-module__typography--neutral-900___RMBjC",
  "typography--grey": "styles-module__typography--grey___M7OjL",
  "typography--grey-50": "styles-module__typography--grey-50___tB-uq",
  "typography--grey-100": "styles-module__typography--grey-100___s9y8j",
  "typography--grey-200": "styles-module__typography--grey-200___vxXw3",
  "typography--grey-300": "styles-module__typography--grey-300___XsRYu",
  "typography--grey-400": "styles-module__typography--grey-400___IWnI7",
  "typography--grey-500": "styles-module__typography--grey-500___7GW0C",
  "typography--grey-600": "styles-module__typography--grey-600___-aO6-",
  "typography--grey-700": "styles-module__typography--grey-700___hSeX7",
  "typography--grey-800": "styles-module__typography--grey-800___PWJ0p",
  "typography--grey-900": "styles-module__typography--grey-900___jE1VL",
  "typography--background": "styles-module__typography--background___VTWwg",
  "typography--background-200": "styles-module__typography--background-200___Doqk2",
  "typography--background-full-white": "styles-module__typography--background-full-white___MF85y",
  "typography--background-grey-50": "styles-module__typography--background-grey-50___resP2",
  "typography--background-neutral-50": "styles-module__typography--background-neutral-50___mdhDI",
  "typography--background-grey-100": "styles-module__typography--background-grey-100___6ctL8",
  "typography--background-tertiary": "styles-module__typography--background-tertiary___aybo3",
  "typography--background-error": "styles-module__typography--background-error___nIFGw",
  "typography--background-tertiary-600": "styles-module__typography--background-tertiary-600___7pgoP",
  "typography--background-error-600": "styles-module__typography--background-error-600___rwQsE",
  "typography--background-neutral-900": "styles-module__typography--background-neutral-900___fCSui",
  "typography--background-neutral-legacy": "styles-module__typography--background-neutral-legacy___jucBC",
  "typography--background-win": "styles-module__typography--background-win___KqPqo",
  "typography--typography": "styles-module__typography--typography___3AQq9",
  "typography--typography-white": "styles-module__typography--typography-white___zOwc4",
  "typography--typography-default": "styles-module__typography--typography-default___nP3kg",
  "typography--typography-link": "styles-module__typography--typography-link___2BuM4",
  "typography--typography-error": "styles-module__typography--typography-error___vrgx9",
  "typography--typography-sucess": "styles-module__typography--typography-sucess___Y7Kz4",
  "typography--typography-disabled": "styles-module__typography--typography-disabled___p01PK",
  "typography--typography-marketing": "styles-module__typography--typography-marketing___1RA2I",
  "typography--typography-secondary": "styles-module__typography--typography-secondary___AgG6V",
  "typography--icons-white": "styles-module__typography--icons-white___-bmdl",
  "typography--icons-dark-grey": "styles-module__typography--icons-dark-grey___6rmu-",
  "typography--icons-blue": "styles-module__typography--icons-blue___aObBr",
  "typography--icons-red": "styles-module__typography--icons-red___RMwoC",
  "typography--icons-success": "styles-module__typography--icons-success___xkauV",
  "typography--icons-warning": "styles-module__typography--icons-warning___XVLCv",
  "typography--icons-info": "styles-module__typography--icons-info___ft3bW",
  "typography--icons-win": "styles-module__typography--icons-win___rFadz",
  "typography--accent": "styles-module__typography--accent___xSwOq",
  "typography--accent-orange": "styles-module__typography--accent-orange___4imt-",
  "typography--accent-light": "styles-module__typography--accent-light___UulHt",
  "typography--ellipsis": "styles-module__typography--ellipsis___muwyX",
  "typography--selectable": "styles-module__typography--selectable___eBuVc",
  H1: _,
  "H1--responsive": "styles-module__H1--responsive___ZgXol",
  H2: r,
  "H2--responsive": "styles-module__H2--responsive___N5jNA",
  paragraph: p,
  "paragraph--responsive": "styles-module__paragraph--responsive___knTaL"
};
export {
  _ as H1,
  r as H2,
  t as default,
  p as paragraph,
  y as typography
};
